import { dataMember, required } from 'santee-dcts';

export function getAgeProjectDays(years: number, months: number, days: number): number {
    let value = 0; 
    if (years) {
        value = years * 365;
    }
    if (months) {
        value += months * 30.417;
    }
    if (days) {
        value += days;
    }
    return value;
}

export function getAgeInDays(value: number, unit: string): number {
    if (!value) {
        return null;
    }
    let scale = 1;
    switch (unit) {
        case 'years':
            scale = 365;
            break;
        case 'months':
            scale = 30.417;
            break;
    }
    return scale * value;
}

export abstract class OnScreenResults {

    @dataMember()
    @required({ nullable: true })
    public zcSubjectId: string;

    @dataMember()
    @required({ nullable: true })
    public subjectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public screeningNumber: string;

    @dataMember()
    @required({ nullable: true })
    public initials: string;

    @dataMember()
    @required({ nullable: true })
    public sex: string;

    @dataMember()
    @required({ nullable: true })
    public age: number;

    @dataMember()
    @required({ nullable: true })
    public ageUnit: string;

    @dataMember()
    @required({ nullable: true })
    public ageProjectDisplayValue: string;

    @dataMember()
    @required({ nullable: true })
    public isAgeProject: boolean;

    @dataMember()
    @required({ nullable: true })
    public ageInYears: number;

    @dataMember()
    @required({ nullable: true })
    public ageInMonths: number;

    @dataMember()
    @required({ nullable: true })
    public ageInDays: number;

    @dataMember()
    @required({ nullable: true })
    public visitDescription: string;

    @dataMember()
    public isTestCancelled: boolean;

    @dataMember()
    public isGroupCancelled: boolean;

    @dataMember()
    public testCancellationReason: string;

    @dataMember()
    public groupCancellationReason: string;

    @dataMember()
    @required()
    public isQuestion: boolean;

    public get isCancelled(): boolean {
        return this.isTestCancelled || this.isGroupCancelled;
    }

    public get daysLived(): number {
        if (this.isAgeProject) {
            return getAgeProjectDays(this.ageInYears, this.ageInMonths, this.ageInDays);
        } else {
            return getAgeInDays(this.age, this.ageUnit);
        }
    }

    public get cancellationReason(): string {

        if (this.isGroupCancelled) {
            return `Test group cancelled: ${this.groupCancellationReason}`;
        } else if (this.isTestCancelled) {
            return `Test cancelled: ${this.testCancellationReason}`;
        }

        return '';
    }
}
